var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('shortCut'),(_vm.$route.meta.showHead)?_c('Header'):_vm._e(),(_vm.apiFinish)?_c('router-view',{staticClass:"mainContent"}):_vm._e(),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }